/**
 * Agent dashboard links used in email.
 * The app is one screen with sections, so these query params open
 * Settings or a homeowner's task after login.
 */

const ID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function trimOrigin(value) {
  return String(value || '').trim().replace(/\/$/, '');
}

function recordId(value) {
  const id = String(value || '').trim();
  return ID_RE.test(id) ? id : '';
}

function agentDashboardUrl(base, query) {
  const root = trimOrigin(base) || 'https://app.pacarion.com';
  const params = new URLSearchParams();
  params.set('login', 'agent');
  Object.keys(query || {}).forEach((key) => {
    const value = query[key];
    if (value != null && String(value) !== '') params.set(key, String(value));
  });
  return `${root}/?${params.toString()}`;
}

function settingsBillingUrl(base) {
  return `${agentDashboardUrl(base, { section: 'settings' })}#billing`;
}

function billingPortalUrl(base) {
  return `${agentDashboardUrl(base, { section: 'settings', billing: 'portal' })}#billing`;
}

function agentTaskUrl(base, clientId, taskId) {
  return agentDashboardUrl(base, {
    section: 'tasks',
    client: recordId(clientId),
    task: recordId(taskId),
  });
}

function readAgentLink(search) {
  const params = new URLSearchParams(String(search || '').replace(/^\?/, ''));
  const section = params.get('section');
  const clientId = recordId(params.get('client'));
  const taskId = recordId(params.get('task'));
  const openBilling = params.get('billing') === 'portal';
  return {
    section: section === 'settings' || section === 'tasks' ? section : '',
    clientId,
    taskId,
    openBilling,
  };
}

module.exports = {
  agentDashboardUrl,
  settingsBillingUrl,
  billingPortalUrl,
  agentTaskUrl,
  readAgentLink,
};
